<template>
  <div class="emotion-modal">
    <span v-for="em in emotionList" :key="em" @click="handleType(em)" class="emotion-item">
      {{ em }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useChatStore } from "../../../store/chat";

export default defineComponent({
  name: "EmotionModal",
  setup() {
    const emotionList = [
      // 笑脸与情感
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "😂",
      "🤣",
      "😊",
      "😇",
      "🙂",
      "🙃",
      "😉",
      "😌",
      "😍",
      "🥰",
      "😘",
      "😗",
      "😙",
      "😚",
      "😋",
      "😛",
      "😝",
      "😜",
      "🤪",
      "🤨",
      "🧐",
      "🤓",
      "😎",
      "🥳",

      // 手势与动作
      "👍",
      "👎",
      "👌",
      "✌️",
      "🤞",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "👇",
      "☝️",
      "👋",
      "🤚",
      "🖐️",
      "✋",
      "🖖",
      "👏",
      "🙌",
      "👐",
      "🤲",
      "🙏",
      "🤝",
      "💪",
      "🦵",
      "🦶",
      "👂",
      "👃",
      "🧠",

      // 心形与情感符号
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❤️‍🔥",
      "❤️‍🩹",
      "💕",
      "💞",
      "💓",
      "💗",
      "💖",
      "💘",
      "💝",
      "💟",

      // 动物与自然
      "🐶",
      "🐱",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐨",
      "🐸",
      "🐒",
      "🐔",
      "🐧",
      "🐦",
      "🐤",
      "🐣",
      "🐥",
      "🦆",
      "🦅",
      "🦉",
      "🐺",
      "🐗",
      "🐴",
      "🦄",
      "🐝",
      "🐛",
      "🦋",
      "🐌",
      "🐞",
      "🐜",

      // 食物与饮品
      "🍎",
      "🍐",
      "🍊",
      "🍋",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🫐",
      "🍈",
      "🍒",
      "🍑",
      "🥭",
      "🍍",
      "🥥",
      "🥝",
      "🍅",
      "🍆",
      "🥑",
      "🥦",
      "🥬",
      "🥒",
      "🌶️",
      "🫑",
      "🌽",
      "🥕",
      "🫒",
      "🧄",
      "🧅",
      "🥔",

      // 活动与运动
      "⚽",
      "🏀",
      "🏈",
      "⚾",
      "🥎",
      "🎾",
      "🏐",
      "🏉",
      "🥏",
      "🎳",
      "🏏",
      "🏑",
      "🏒",
      "🥍",
      "🏓",
      "🏸",
      "🥊",
      "🥋",
      "⛳",
      "⛸️",

      // 物体与符号
      "⌚",
      "📱",
      "💻",
      "⌨️",
      "🖥️",
      "🖨️",
      "🖱️",
      "🖲️",
      "🕹️",
      "💽",
      "💾",
      "💿",
      "📀",
      "📷",
      "📸",
      "📹",
      "🎥",
      "📽️",
      "🎞️",
      "📞",

      // 旅行与地点
      "🚗",
      "🚕",
      "🚙",
      "🚌",
      "🚎",
      "🏎️",
      "🚓",
      "🚑",
      "🚒",
      "🚐",
      "🚚",
      "🚛",
      "🚜",
      "🛴",
      "🚲",
      "🛵",
      "🏍️",
      "🛺",
      "🚨",
      "🚔",
    ];

    const cStore = useChatStore();

    const handleType = (em: string) => {
      cStore.chatContent += em;
    };

    return { emotionList, handleType };
  },
});
</script>

<style lang="less" scoped>
.emotion-modal {
  background-color: white;
  position: absolute;
  border-radius: 2px;
  top: -158px;
  left: 0;
  width: 100%;
  height: 150px;
  box-shadow: 0 0 10px 0 rgba(224, 227, 224, 0.6);
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  gap: 16px;
  padding: 4px;
}

.emotion-item {
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    scale: 0.9;
  }
}
</style>
